<template>
  <Layout>
    <PageHeader
      :items="items"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Lista de encuestas</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'poll' }"
          >
            Crear
            <b-icon
              class="icon-plus"
              icon="plus-circle-fill"
            ></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <b-overlay
          :show="isSaving"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-xxl-12 col-md-12 p-0 mr-0 ml-0">
              <BaseDatatable
                ref="table"
                :drfprovider="getPollData"
                :tableheaders="fields"
              >
                <template #head(actions)>
                  <span class="title-actions d-flex justify-content-center">Acciones</span>
                  <div class="d-flex content-actions">
                    <span>Editar</span>
                    <span>Eliminar</span>
                  </div>
                </template>
                <template v-slot:cell(pub_state)="row">{{
                  pubStates.find((x) => x.id === row.item.pub_state).text
                }}</template>
                <template v-slot:cell(meta__modified_at)="row">{{
                  row.item.meta.modified_at
                }}</template>
                <template v-slot:cell(state)="row">
                  <span
                    :class="
                      row.item.state === 'A' ? 'text-success' : 'text-danger'
                    "
                    >{{
                      States.find((x) => x.id === row.item.state).text
                    }}</span
                ></template>
                <template v-slot:cell(actions)="row">
                  <b-button-group size="xs" class="d-flex">
                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="btn-link btn-hover text-info btn-transparent"
                      size="xs"
                      @click.prevent="
                        $router.push({
                          name: 'pollForm',
                          params: { pollId: row.item.id },
                        })
                      "
                    >
                      <b-icon-pencil></b-icon-pencil>
                    </b-button>
                    <b-button
                      :id="`delete-btn-${row.index}`"
                      variant="btn-link text-danger btn-transparent"
                      size="xs"
                      @click.prevent="deletePollsData(row.item.id)"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                  </b-button-group>
                </template>
              </BaseDatatable>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { formMethods, pollMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'

export default {
  page: {
    title: 'Lista de Encuestas',
  },
  components: { Layout, PageHeader, BaseDatatable },
  data() {
    return {
      isSaving: false,
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Lista de Encuestas',
          active: true,
        },
      ],
      itemsList: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'title', label: 'Nombre de la Encuesta', sortable: true },
        { key: 'pub_version', label: 'Versión', sortable: true },
        { key: 'pub_state', label: 'Publicación', sortable: true },
        { key: 'state', label: 'Estado', sortable: true },
        {
          key: 'meta__modified_at',
          label: 'Fecha Modificación',
          sortable: true,
        },
        { key: 'actions', label: 'Acciones' },
      ],
      pubStates: [
        { id: '', text: 'Sin guardar' },
        { id: 'N', text: 'No Publicado' },
        { id: 'P', text: 'Publicado' },
        { id: 'X', text: 'Pausado' },
      ],
      States: [{ id: 'A', text: 'Activo' }, { id: 'I', text: 'Inactivo' }],
      extraButtons: [
        {
          variant: 'info',
          title: 'Crear nueva Encuesta',
          label: 'Crear',
          to: { name: 'form' },
          icon: 'plus-circle-fill',
        },
      ],
    }
  },

  // mounted() {
  //   this.getFormData()
  // },

  methods: {
    ...pollMethods,
    deletePollsData(id) {
      let validate = 'True'
      const promise = this.deletePoll({ id, validate })
      return promise
        .then((data) => {
          let title = ''
          let html = ''
          let typeSwall = ''
          let accion = ''
          if (data.Action == 'Delete') {
            accion = 'Sí, Eliminar'
            title = 'Eliminar Encuesta #' + id
            html =
              data.Message +
              '</br><span class="confirmDes">¿Confirma que deseas eliminar la Encuesta #' +
              id +
              '?</span>'
            typeSwall = 'danger'
          } else {
            accion = 'Sí, Desactivar'
            title = 'Deshabilitar Encuesta #' + id
            html =
              data.Message +
              '</br><span class="confirmDes">¿Confirma que deseas deshabilitar la Encuesta #' +
              id +
              '?</span>'
            typeSwall = 'warning'
          }
          this.$swal({
            title,
            html,
            buttons: { cancel: true, confirm: true },
            confirmButtonText: accion,
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            showCloseButton: true,
            width: '660px',
            position: 'top',
            customClass: {
              title: 'text-' + typeSwall,
              confirmButton: 'btn btn-primary rounded-pill order-2',
              cancelButton: 'btn bg-white text-dark rounded-pill order-1',
            },
            showClass: {
              backdrop: 'swal2-backdrop-show swal2-backdrop-' + typeSwall,
            },
          }).then((isconfirm) => {
            if (isconfirm.value == true) {
              this.isSaving = true
              validate = 'False'
              const promise = this.deletePoll({ id, validate })
              return promise
                .then((data) => {
                  this.$refs.table.refresh()
                  this.isSaving = false
                  this.$generate_noty(
                    'success',
                    `Acción ejecutada correctamente`,
                    28000
                  )
                })
                .catch((error) => {
                  this.isSaving = false
                  this.$generate_noty(
                    'error',
                    'Se presentó un error con el servidor por favor valida más tarde'
                  )
                  console.log(
                    'Se presento un error Ejecutando la acción.',
                    error
                  )
                })
            } else {
              this.isSaving = false
            }
          })
        })
        .catch((error) => {
          this.isSaving = false
          this.$generate_noty(
            'error',
            'Se presentó un error con el servidor por favor valida más tarde'
          )
          console.log('Se presento un error Ejecutando la acción.', error)
        })
    },
    getPollData(ctx) {
      const promise = this.getPolls({
        query: this.$table_params(ctx) + '&list=true',
      })
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las encuestas.',
            error
          )
        })
    },
  },
}
</script>

<style lang="scss">
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
</style>
